export default __webpack_public_path__ + "static/media/apple.e04fb8bc.svg";